export default function OilSpillMonitoring() {
  const pollutionData = [
    { id: 'OIL001', location: '东港海域A区', type: '油污', area: '120㎡', severity: '中', detectionTime: '2024-01-15 08:30', status: '处理中' },
    { id: 'OIL002', location: '西港海域B区', type: '油污', area: '45㎡', severity: '低', detectionTime: '2024-01-15 10:15', status: '已处理' },
    { id: 'SUS001', location: '码头C区水域', type: '悬浮物', concentration: '85mg/L', severity: '低', detectionTime: '2024-01-15 11:00', status: '监控中' },
    { id: 'OIL003', location: '南港海域D区', type: '油污', area: '280㎡', severity: '高', detectionTime: '2024-01-15 14:20', status: '紧急处理' },
  ];

  const alertRecords = [
    { id: 'ALT001', location: '东港海域A区', alertType: '油污超标', threshold: '100㎡', actual: '120㎡', alertTime: '2024-01-15 08:30', handled: true },
    { id: 'ALT002', location: '南港海域D区', alertType: '油污超标', threshold: '100㎡', actual: '280㎡', alertTime: '2024-01-15 14:20', handled: false },
    { id: 'ALT003', location: '码头C区水域', alertType: '悬浮物超标', threshold: '50mg/L', actual: '85mg/L', alertTime: '2024-01-15 11:00', handled: true },
  ];

  return (
    <div className="space-y-6">
      {/* 统计卡片 */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6 border border-teal-500/20">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-gray-400">监测海域面积</span>
            <i className="ri-water-flash-line text-2xl text-teal-400"></i>
          </div>
          <div className="text-3xl font-bold text-white mb-1">15.8km²</div>
          <div className="text-xs text-teal-400">全天候覆盖</div>
        </div>

        <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6 border border-teal-500/20">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-gray-400">今日污染事件</span>
            <i className="ri-alert-line text-2xl text-orange-400"></i>
          </div>
          <div className="text-3xl font-bold text-white mb-1">4</div>
          <div className="text-xs text-orange-400">1个紧急处理</div>
        </div>

        <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6 border border-teal-500/20">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-gray-400">水质达标率</span>
            <i className="ri-checkbox-circle-line text-2xl text-green-400"></i>
          </div>
          <div className="text-3xl font-bold text-white mb-1">92.3%</div>
          <div className="text-xs text-green-400">本周平均</div>
        </div>

        <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6 border border-teal-500/20">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-gray-400">预警响应时间</span>
            <i className="ri-time-line text-2xl text-blue-400"></i>
          </div>
          <div className="text-3xl font-bold text-white mb-1">8min</div>
          <div className="text-xs text-blue-400">平均响应</div>
        </div>
      </div>

      {/* 污染分布图 */}
      <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6 border border-teal-500/20">
        <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
          <i className="ri-map-pin-line text-teal-400"></i>
          海域污染分布图
        </h3>
        <div className="relative rounded-lg overflow-hidden h-96">
          <img 
            src="https://public.readdy.ai/ai/img_res/b10ea66eebd164da0b84a72d87cc1ac0.jpg"
            alt="污染分布图"
            className="w-full h-full object-cover"
          />
          <div className="absolute top-4 right-4 bg-black/80 backdrop-blur-sm rounded-lg p-4 space-y-2">
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 bg-red-500 rounded-full"></div>
              <span className="text-white text-sm">高污染区</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 bg-orange-500 rounded-full"></div>
              <span className="text-white text-sm">中污染区</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 bg-yellow-500 rounded-full"></div>
              <span className="text-white text-sm">低污染区</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 bg-green-500 rounded-full"></div>
              <span className="text-white text-sm">正常区域</span>
            </div>
          </div>
          <div className="absolute bottom-4 left-4 bg-black/80 backdrop-blur-sm rounded-lg p-3">
            <div className="text-white text-sm font-medium">实时监测数据</div>
            <div className="text-teal-400 text-xs">更新时间: 2024-01-15 16:30</div>
          </div>
        </div>
      </div>

      {/* 监测画面 */}
      <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6 border border-teal-500/20">
        <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
          <i className="ri-camera-line text-teal-400"></i>
          实时监测画面
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="relative rounded-lg overflow-hidden h-48">
            <img 
              src="https://readdy.ai/api/search-image?query=oil%20spill%20on%20water%20surface%20close-up%20view%20showing%20rainbow%20sheen%20pattern%2C%20professional%20environmental%20monitoring%20photography%2C%20clear%20detail%20of%20oil%20pollution%20on%20sea%20water%2C%20technical%20documentation%20angle%2C%20natural%20daylight%2C%20visible%20oil%20slick%20texture&width=600&height=400&seq=oil-spill-monitor-001&orientation=landscape"
              alt="油污监测"
              className="w-full h-full object-cover"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-3">
              <div className="text-white text-sm font-medium">东港海域A区油污</div>
              <div className="text-orange-400 text-xs">面积120㎡ - 处理中</div>
            </div>
          </div>
          <div className="relative rounded-lg overflow-hidden h-48">
            <img 
              src="https://readdy.ai/api/search-image?query=severe%20oil%20pollution%20on%20harbor%20water%20surface%20aerial%20view%20showing%20large%20contaminated%20area%2C%20environmental%20disaster%20monitoring%2C%20professional%20drone%20photography%2C%20extensive%20oil%20slick%20visible%2C%20industrial%20port%20background%2C%20urgent%20situation%20documentation&width=600&height=400&seq=oil-spill-monitor-002&orientation=landscape"
              alt="严重污染"
              className="w-full h-full object-cover"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-3">
              <div className="text-white text-sm font-medium">南港海域D区严重污染</div>
              <div className="text-red-400 text-xs">面积280㎡ - 紧急处理</div>
            </div>
          </div>
          <div className="relative rounded-lg overflow-hidden h-48">
            <img 
              src="https://readdy.ai/api/search-image?query=water%20quality%20monitoring%20showing%20suspended%20particles%20in%20harbor%20water%2C%20professional%20environmental%20testing%20photography%2C%20clear%20water%20sample%20with%20visible%20turbidity%2C%20technical%20analysis%20perspective%2C%20laboratory%20quality%20documentation%20style%2C%20controlled%20lighting&width=600&height=400&seq=oil-spill-monitor-003&orientation=landscape"
              alt="悬浮物监测"
              className="w-full h-full object-cover"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-3">
              <div className="text-white text-sm font-medium">码头C区悬浮物监测</div>
              <div className="text-yellow-400 text-xs">浓度85mg/L - 监控中</div>
            </div>
          </div>
        </div>
      </div>

      {/* 污染数据 */}
      <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6 border border-teal-500/20">
        <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
          <i className="ri-file-list-line text-teal-400"></i>
          污染事件记录
        </h3>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-gray-700">
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">事件编号</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">位置</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">污染类型</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">污染程度</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">严重程度</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">检测时间</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">处理状态</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">操作</th>
              </tr>
            </thead>
            <tbody>
              {pollutionData.map((data) => (
                <tr key={data.id} className="border-b border-gray-700/50 hover:bg-gray-700/30 transition-colors">
                  <td className="py-3 px-4 text-sm text-white">{data.id}</td>
                  <td className="py-3 px-4 text-sm text-white">{data.location}</td>
                  <td className="py-3 px-4 text-sm text-gray-300">{data.type}</td>
                  <td className="py-3 px-4 text-sm text-gray-300">
                    {data.area || data.concentration}
                  </td>
                  <td className="py-3 px-4">
                    <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                      data.severity === '低' ? 'bg-yellow-500/20 text-yellow-400' :
                      data.severity === '中' ? 'bg-orange-500/20 text-orange-400' :
                      'bg-red-500/20 text-red-400'
                    }`}>
                      {data.severity}
                    </span>
                  </td>
                  <td className="py-3 px-4 text-sm text-gray-300">{data.detectionTime}</td>
                  <td className="py-3 px-4">
                    <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                      data.status === '已处理' ? 'bg-green-500/20 text-green-400' :
                      data.status === '监控中' ? 'bg-blue-500/20 text-blue-400' :
                      data.status === '处理中' ? 'bg-orange-500/20 text-orange-400' :
                      'bg-red-500/20 text-red-400'
                    }`}>
                      {data.status}
                    </span>
                  </td>
                  <td className="py-3 px-4">
                    <button className="text-teal-400 hover:text-teal-300 text-sm cursor-pointer whitespace-nowrap">
                      查看详情
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* 预警记录 */}
      <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6 border border-teal-500/20">
        <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
          <i className="ri-alarm-warning-line text-orange-400"></i>
          预警记录
        </h3>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-gray-700">
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">预警编号</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">位置</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">预警类型</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">阈值</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">实际值</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">预警时间</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">处理状态</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">操作</th>
              </tr>
            </thead>
            <tbody>
              {alertRecords.map((alert) => (
                <tr key={alert.id} className="border-b border-gray-700/50 hover:bg-gray-700/30 transition-colors">
                  <td className="py-3 px-4 text-sm text-white">{alert.id}</td>
                  <td className="py-3 px-4 text-sm text-white">{alert.location}</td>
                  <td className="py-3 px-4 text-sm text-gray-300">{alert.alertType}</td>
                  <td className="py-3 px-4 text-sm text-gray-300">{alert.threshold}</td>
                  <td className="py-3 px-4 text-sm text-red-400 font-medium">{alert.actual}</td>
                  <td className="py-3 px-4 text-sm text-gray-300">{alert.alertTime}</td>
                  <td className="py-3 px-4">
                    <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                      alert.handled ? 'bg-green-500/20 text-green-400' : 'bg-red-500/20 text-red-400'
                    }`}>
                      {alert.handled ? '已处理' : '待处理'}
                    </span>
                  </td>
                  <td className="py-3 px-4">
                    <button className="text-teal-400 hover:text-teal-300 text-sm cursor-pointer whitespace-nowrap">
                      查看详情
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}